/**
 * @FileDescription: 工具类/组件 全局注册
 * @Author: zhuangjinshan
 * @Date: 2023-08-16
 * @LastEditors: zhuangjinshan
 * @LastEditTime: 2023-08-16
 */
import Vue from "vue";

import '@/assets/styles/main.less';

// 本地缓存
import LocalCache from '@/localCache';
Vue.prototype.$localCache = LocalCache;

// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// element-ui message二次封装
import message from './message.js';
Vue.prototype.$message = message;

// 公共组件
import ConnectUs from '@/components/ConnectUs.vue';
Vue.component('ConnectUsPopover', ConnectUs);
